import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const withdrawalApi = createApi({
  reducerPath: 'withdrawalApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://api.codebondingworkforce.com/api/withdrawals/',
    prepareHeaders: (headers) => {
      // Add authorization header if needed
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Withdrawals'],
  endpoints: (builder) => ({
    getWithdrawals: builder.query({
      query: ({ page = 1, limit = 10, status, search }) => {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('limit', limit);
        if (status && status !== 'all') params.append('status', status);
        if (search) params.append('search', search);
        
        return `admin?${params.toString()}`;
      },
      providesTags: ['Withdrawals'],
      transformResponse: (response) => ({
        withdrawals: response.data,
        meta: response.meta
      })
    }),
    updateWithdrawalStatus: builder.mutation({
      query: ({ withdrawalId, status }) => ({
        url: `${withdrawalId}/status`,
        method: 'POST',
        body: { status }
      }),
      invalidatesTags: ['Withdrawals']
    })
  })
});

export const {
  useGetWithdrawalsQuery,
  useUpdateWithdrawalStatusMutation
} = withdrawalApi;